module.exports = __webpack_public_path__ + "static/persona-1-8d1fbb06abff15c05cf1fb767ea7584a.png";